import { SystemStyleObject } from '@styled-system/css';
import { RGBColor } from 'react-color';

export const fillColorStyles = (color?: RGBColor, defaultThemeColor = 'primary'): SystemStyleObject => ({
  backgroundColor: color ? `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})` : defaultThemeColor,
});
